const CONSTANTS = {
  PLANT_SERVICE: "https://sheet.best/api/sheets/d4e1305d-4b8f-41dd-ad96-e3b9d67673b5",
  CREDENTIALS: [
    {
      "first_name": "Ankit",
      "last_name": "Khandelwal",
      "department": "Account",
      "email": "ankit@optifinish.in",
      "password": "salesadmin",
      "user_name": "AnkitKhandelwal",
      "Is_service_access": false,
      "Is_gun_catalogue_access": true
    },
    {
      "first_name": "Kumar",
      "last_name": "Shaswat",
      "department": "Designing",
      "email": "kumar@optifinish.in",
      "password": "salesadmin",
      "user_name": "KumarShaswat",
      "Is_service_access": false,
      "Is_gun_catalogue_access": false
    },
    {
      "first_name": "Harish",
      "last_name": "Sharma",
      "department": "Director",
      "email": "harish@optifinish.in",
      "password": "salesadmin",
      "user_name": "HarishSharma",
      "Is_service_access": true,
      "Is_gun_catalogue_access": true
    },
    {
      "first_name": "Lalit",
      "last_name": "Tayal",
      "department": "Director",
      "email": "lalit@optifinish.in",
      "password": "salesadmin",
      "user_name": "LalitTayal",
      "Is_service_access": true,
      "Is_gun_catalogue_access": true
    },
    {
      "first_name": "Lakshay",
      "last_name": ".",
      "department": "Equipment",
      "email": "lakshay@optifinish.in",
      "password": "salesadmin",
      "user_name": "Lakshay.",
      "Is_service_access": false,
      "Is_gun_catalogue_access": true
    },
    {
      "first_name": "Pankaj",
      "last_name": "Sharma",
      "department": "Equipment",
      "email": "pankajsharma@optifinish.in",
      "password": "salesadmin",
      "user_name": "PankajSharma",
      "Is_service_access": false,
      "Is_gun_catalogue_access": true
    },
    {
      "first_name": "Shyam",
      "last_name": "Sunder",
      "department": "godown",
      "email": "shyamsundar@optifinish.in",
      "password": "salesadmin",
      "user_name": "ShyamSunder",
      "Is_service_access": false,
      "Is_gun_catalogue_access": false
    },
    {
      "first_name": "Bharat",
      "last_name": "Singh",
      "department": "Installation-Plant",
      "email": "bharat@optifinish.in",
      "password": "salesadmin",
      "user_name": "BharatSingh",
      "Is_service_access": false,
      "Is_gun_catalogue_access": true
    },
    {
      "first_name": "Sartaj",
      "last_name": "Khan",
      "department": "Management",
      "email": "marketing@optifinish.in",
      "password": "salesadmin",
      "user_name": "SartajKhan",
      "Is_service_access": true,
      "Is_gun_catalogue_access": true
    },
    {
      "first_name": "Jagdishbhai",
      "last_name": "Ganeshbhai Rohit",
      "department": "Powder",
      "email": "jagdish@optifinish.in",
      "password": "salesadmin",
      "user_name": "JagdishbhaiGaneshbhai Rohit",
      "Is_service_access": false,
      "Is_gun_catalogue_access": false
    },
    {
      "first_name": "Jasveer",
      "last_name": "Nayak",
      "department": "Powder",
      "email": "jasveernayak@optifinish.in",
      "password": "salesadmin",
      "user_name": "JasveerNayak",
      "Is_service_access": false,
      "Is_gun_catalogue_access": false
    },
    {
      "first_name": "Mahtab",
      "last_name": "Ansari",
      "department": "Powder",
      "email": "mahtab@optifinish.in",
      "password": "salesadmin",
      "user_name": "MahtabAnsari",
      "Is_service_access": false,
      "Is_gun_catalogue_access": false
    },
    {
      "first_name": "Pawan",
      "last_name": "Singh",
      "department": "Powder",
      "email": "pawansingh@optifinish.in",
      "password": "salesadmin",
      "user_name": "PawanSingh",
      "Is_service_access": false,
      "Is_gun_catalogue_access": false
    },
    {
      "first_name": "Ravi",
      "last_name": "Bhardwaj",
      "department": "Powder",
      "email": "ravibhardwaj@optifinish.in",
      "password": "salesadmin",
      "user_name": "RaviBhardwaj",
      "Is_service_access": false,
      "Is_gun_catalogue_access": false
    },
    {
      "first_name": "Vineet",
      "last_name": "Kumar",
      "department": "Powder",
      "email": "vineet@optifinish.in",
      "password": "salesadmin",
      "user_name": "VineetKumar",
      "Is_service_access": false,
      "Is_gun_catalogue_access": false
    },
    {
      "first_name": "Man",
      "last_name": "Singh",
      "department": "Rururpur-Godown",
      "email": "mansingh@optifinish.in",
      "password": "salesadmin",
      "user_name": "ManSingh",
      "Is_service_access": false,
      "Is_gun_catalogue_access": false
    },
    {
      "first_name": "Abhishek",
      "last_name": ".",
      "department": "Service",
      "email": "abhishek@optifinish.in",
      "password": "salesadmin",
      "user_name": "Abhishek.",
      "Is_service_access": true,
      "Is_gun_catalogue_access": false
    },
    {
      "first_name": "Indrajit",
      "last_name": "Yadav",
      "department": "Service",
      "email": "indrajit@optifinish.in",
      "password": "salesadmin",
      "user_name": "IndrajitYadav",
      "Is_service_access": true,
      "Is_gun_catalogue_access": false
    },
    {
      "first_name": "Manoj",
      "last_name": "Rawat",
      "department": "Service",
      "email": "manoj@optifinish.in",
      "password": "salesadmin",
      "user_name": "ManojRawat",
      "Is_service_access": true,
      "Is_gun_catalogue_access": false
    },
    {
      "first_name": "Rahul",
      "last_name": "Kumar",
      "department": "Service",
      "email": "rahul@optifinish.in",
      "password": "salesadmin",
      "user_name": "RahulKumar",
      "Is_service_access": true,
      "Is_gun_catalogue_access": false
    },
    {
      "first_name": "Project",
      "last_name": "Team",
      "department": "",
      "email": "project1@optifinish.in",
      "password": "salesadmin",
      "user_name": "ProjectTeam",
      "Is_service_access": false,
      "Is_gun_catalogue_access": false
    }
  ],
  GUN_QUOTATION_SHEET_MACRO_URL: "https://script.google.com/macros/s/AKfycby2NSDWmUdne6ikdwSKo0SWmdJztv8hFkoC65t3vKFozSHUbKtjA1klxA2E77sRXnYo/exec",
  GUN_QUOTATION_SENT_SHEET: "https://docs.google.com/spreadsheets/d/1hRfjNpwfjwOVaUcxlmDy-ia36cC3MjdjhnJJUVRaRq4/edit#gid=0",
  // API_URL: "http://localhost:5000/",
  API_URL: "https://vacspl.in/",
  // API_URL: "http://vacspl-api-env-1.eba-2ifitxtw.ap-south-1.elasticbeanstalk.com/",
  LOCAL_API_URL: "http://localhost:5000/",
  QUOTATION_TABLE: {
    HEADS: [
      { key: "quotation_date", displayName: "Date" },
      { key: "client_name", displayName: "Client" },
      { key: "employee_name", displayName: "Vacspl Engineer" },
      { key: "client_city", displayName: "City" },
      { key: "client_state", displayName: "State" },
      { key: "client_email", displayName: "Email" },
      { key: "contact_person_name", displayName: "Contact Person" },
      { key: "contact_person_phone", displayName: "Phone" },
      { key: "quotation_amt", displayName: "Amount" },
      { key: "contact_person_email", displayName: "Email" },
      { key: "current_status", displayName: "Status" },
    ],
    TITLE: "List of quotations"
  },
  SERVICE_LIST_TABLE: {
    HEADS: [
      { key: "date_of_service", displayName: "Date" },
      { key: "service_engineer_name", displayName: "Engineer" },
      { key: "client_name", displayName: "Client" },
      { key: "client_address", displayName: "Address" },
      { key: "client_email", displayName: "Email" },
      { key: "contact_person_phone", displayName: "Phone" },
    ],
    TITLE: "List of Service Reports"
  },
  SERVICE_LIST_TABLE_NEW: {
    HEADS: [
      { key: "date_of_service", displayName: "Date" },
      { key: "service_engineer_name", displayName: "Engineer" },
      { key: "client_name", displayName: "Client" },
      // { key: "client_address", displayName: "Address" },
      // { key: "client_email", displayName: "Email" },
      // { key: "contact_person_phone", displayName: "Phone" },
      { key: "service_book_number", displayName: "Book No." },
      { key: "is_quotation_required", displayName: "Need Quotation?" },
    ],
    TITLE: "List of Service Reports"
  },
  IMLEAD_LIST_TABLE: {
    HEADS: [
      { key: "QUERY_TIME", displayName: "Date" },
      { key: "SENDER_NAME", displayName: "Name" },
      { key: "SENDER_MOBILE", displayName: "Mobile" },
      { key: "SENDER_EMAIL", displayName: "Email" },
      { key: "QUERY_PRODUCT_NAME", displayName: "Enquiry" },
      { key: "SENDER_COMPANY", displayName: "Company" },
      { key: "SENDER_CITY", displayName: "City" },
      { key: "SENDER_STATE", displayName: "State" },
      // { key: "SENDER_MOBILE_ALT", displayName: "SENDER_MOBILE_ALT" },
      // { key: "SENDER_EMAIL_ALT", displayName: "SENDER_EMAIL_ALT" },
    ],
    TITLE: "List of Leads"
  },
  CUSTOMER_LIST_TABLE:{
    HEADS:[
      { key: "client_name", displayName: "Customer Name" },
      { key: "client_address", displayName: "Address" },
      { key: "client_email", displayName: "Email" },
      { key: "date_of_service", displayName: "Last Service Date" },
      { key: "date_of_service", displayName: "Edit" },
    ],
    TITLE:"Cients"
  },
  documentsConfigs: [
    {
      key: "",
      slug: "",
      displayName: "Manual Gun",
      url: "https://drive.google.com/file/d/1wPzSPjMxmLjSp8E38P-vVBDlFr6CFQ_k/view"
    },
    {
      key: "",
      slug: "",
      displayName: "Gema Manual Gun Controller - Catalogue",
      url: "https://drive.google.com/file/d/1vPtgE241K9qMSAGc-7CH_TyVzQEerzEK/view"
    },
    {
      key: "",
      slug: "",
      displayName: "Gema Manual Gun Injector - Catalogue",
      url: "https://drive.google.com/file/d/1s9KxvnobuaN6_TGaBO8gXCWOnWH4fG_D/view"
    },
    {
      key: "",
      slug: "",
      displayName: "Gema Manual Gun - Instruction / Maintenance",
      url: "https://drive.google.com/file/d/150I27vYhzTG1Zal36NM37AopBBwvYEGS/view"
    },
    {
      key: "",
      slug: "",
      displayName: "Gema - Catalogue",
      url: "https://drive.google.com/file/d/1SOT1ajDmENLkmFDGZa81kxCo06VQovkm/view"
    },
    {
      key: "",
      slug: "",
      displayName: "Catalogue - VACSPL",
      url: "https://drive.google.com/file/d/1wPzSPjMxmLjSp8E38P-vVBDlFr6CFQ_k/view"
    },
    {
      key: "",
      slug: "",
      displayName: "Training Module Format",
      url: "https://drive.google.com/file/d/1erZOV9OvWE7pStSMSpjMTn_giHiIbZLB/view"
    }
  ],
  SHEETS: {
    ALL_SERVICE_RECORD_SHEET: "https://docs.google.com/spreadsheets/d/1p-t5-g3XUxAtGBfRnrH6w5Kmx4Nj5CZ9C4MkWNHt4nU/edit?pli=1&gid=0#gid=0",
  },
  subjectLines: [
    "Value Added Coating Solution: Inspection Findings",
    "Service Report from Value Added Coating Solution",
    "Value Added Coating Solution Follow-Up: Equipment Inspection",
    "Inspection Report by Value Added Coating Solution",
    "Inspection Findings by Value Added Coating Solution",
    "Value Added Coating Solution Service Update: Parts Needed for Optimal Operation",
    "Value Added Coating Solution – Detailed Service Report and Maintenance Needs",
    "Immediate Recommendations by Value Added Coating Solution for Equipment Restoration",
    "Inspection Findings: Required Components from Value Added Coating Solution",
    "Value Added Coating Solution: Inspection and Maintenance Report Attached"
  ],
  subjectLinesOkayService:[
    "Value Added Coating Solution: Inspection Findings",
    "Service Report from Value Added Coating Solution",
    "Value Added Coating Solution Follow-Up: Equipment Inspection",
    "Inspection Report by Value Added Coating Solution",
    "Inspection Findings by Value Added Coating Solution",
    "Value Added Coating Solution: Inspection and Maintenance Report Attached"
  ],
  SPARE_UNIT:[
    {key:"Mtr.", value:"mtr"},
    {key:"Nos.", value:"no"},
  ],
  SPARE_UNIT_MAPPING:{
    mtr:"Mtr.",
    no:"Nos."
  },
  MODE_OF_SERVICE:[
    {
      value:"physical",
      key:"Company Visit",
      helperText:"Aapne customer k pas jake service ki"
    },
    {
      value:"in_office_service",
      key:"In Office Service",
      helperText:"Customer ka component yhi mangavaya gya, phir check kiya gya"
    },
    {
      value:"video_call",
      key:"On Video Call",
      helperText:"Video Call pr service ki / issue solve karaya"
    },

  ],
  INITIATION_TYPE_OF_SERVICE:[
    {
      value:"complain",
      key:"Customer Complain",
      helperText:"Customer ne complain ki thi"
    },
    {
      value:"random_visit",
      key:"Normal Visit",
      helperText:"Khud se visit customer k yha visit ki"
    }
  ]

}



export default CONSTANTS